import type { TOC } from '@ember/component/template-only';

import HomePageComponent from 'webapp/components/home/page';

const IndexRouteTemplate: TOC<object> = <template><HomePageComponent /></template>;

export default IndexRouteTemplate;
